<link rel="ractive" href="./html.html" name="c-html">

<div class="c-markdown">
	<c-html html="{{html}}"></c-html>
</div>

<script>
	const _ = require('../../assets/js/_.js');
	const createMarkedRenderer = require('../../assets/js/utils/marked-renderer');
	const ID_PREFIX = 'id-';

	component.exports = {
		data () {
			return {
				_,
				html: '',
				markdown: '',
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				app.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');

				Promise.all([
					// eslint-disable-next-line n/no-missing-import
					import('https://cdn.jsdelivr.net/npm/marked@17.0.1/+esm'),
					// eslint-disable-next-line n/no-missing-import
					import('https://cdn.jsdelivr.net/npm/marked-gfm-heading-id@4.1.3/+esm'),
					// eslint-disable-next-line n/no-missing-import
					import('https://cdn.jsdelivr.net/npm/marked-highlight@2.2.3/+esm'),
					// eslint-disable-next-line n/no-missing-import
					import('https://cdn.jsdelivr.net/npm/@highlightjs/cdn-assets@11.7.0/es/highlight.min.js'),
				]).then(([{ marked, Renderer }, { gfmHeadingId }, { markedHighlight }, { default: hljs }]) => {
					marked.use({
						renderer: createMarkedRenderer(Renderer),
					});

					marked.use(gfmHeadingId({
						prefix: ID_PREFIX,
					}));

					marked.use(markedHighlight({
						langPrefix: 'hljs language-',
						highlight (code, language) {
							return hljs.getLanguage(language) ? hljs.highlightAuto(code, [ 'html', 'javascript', 'sh', 'bash' ]).value : code;
						},
					}));

					this.observe('markdown', (md) => {
						this.set('html', marked.parse(md));
					});
				});
			}
		},
	};
</script>
